import React from 'react';

const ErrorIcon = ({ color }: { color: string }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5 8C15.5 12.2812 12.0299 15.75 7.75 15.75C3.47009 15.75 0 12.2812 0 8C0 3.72134 3.47009 0.25 7.75 0.25C12.0299 0.25 15.5 3.72134 15.5 8ZM7.75 9.5625C6.95609 9.5625 6.3125 10.2061 6.3125 11C6.3125 11.7939 6.95609 12.4375 7.75 12.4375C8.54391 12.4375 9.1875 11.7939 9.1875 11C9.1875 10.2061 8.54391 9.5625 7.75 9.5625ZM6.38522 4.39544L6.61703 8.64544C6.62787 8.84431 6.79231 9 6.99147 9H8.50853C8.70769 9 8.87213 8.84431 8.88297 8.64544L9.11478 4.39544C9.1265 4.18063 8.95547 4 8.74034 4H6.75962C6.5445 4 6.3735 4.18063 6.38522 4.39544Z"
        fill={color}
      />
    </svg>
  );
};

export default ErrorIcon;
